<div class="sidebar-new sec-content" [style.width]="isSideMenuShow ? '400px':sideMenuWidth">
  <div class="b-btn medium-sans d-flex align-items-center back-btn ">
    <div class="p-1 cursor-pointer me-2 place-center " (click)="onGoBack()">
      <i class="material-icons">keyboard_backspace</i>
    </div>
    <span class="heading-2">{{courseData.title}}</span>
  </div>
  <div class="section-panel" [style.width]="isSideMenuShow ? '400px':'27px'">
    <div class="ex-collapse d-box cursor-pointer" (click)="onSideMenuDisplay()" [style.right]="rightIconAlign">
      <i class="material-icons" *ngIf="!isSideMenuShow">keyboard_arrow_left</i>
      <i class="material-icons" *ngIf="isSideMenuShow">keyboard_arrow_right</i>
    </div>
    <div *ngIf="isSideMenuShow" class="course">

      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
        *ngFor="let item of sectionDataArr;let i=index" [expanded]="item.s_i==subSectionData.s_i">
        <mat-expansion-panel-header class="ti-box medium-sans">
          <mat-panel-title class="se-b d-flex medium-sans">
            <div class="num-box me-2 ">{{i+1}}</div>
            <div class="panel-title">{{item.s_tit}} </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="template-content-box ">
          <div class="item-box d-flex align-items-center cursor-pointer" *ngFor="let value of item.sub_s;let j=index"
            (click)="onSubSection(item.s_i,value,item)" [ngClass]="{'sel-sec':value.s_si==subSectionData.id}">
            <div class="d-flex justify-content-between ps-4 align-items-center  w-100">
              <div class="d-flex align-items-center">
                <div class="object-icon me-2">
                  <img *ngIf="value.type=='text'" src="assets/images/object_icons_new/text.svg" class="img-fluid"
                    alt="">
                  <img *ngIf="value.type=='audio'" src="assets/images/object_icons/audio.svg" class="img-fluid" alt="">
                  <img *ngIf="value.type=='video'" src="assets/images/object_icons/video.svg" class="img-fluid" alt="">
                  <img *ngIf="value.type=='youtube'" src="assets/images/object_icons_new/youtube.svg" class="img-fluid"
                    alt="">
                  <img *ngIf="value.type=='pdf'" src="assets/images/object_icons_new/pdf.svg" class="img-fluid" alt="">
                  <img *ngIf="value.type=='file'" src="assets/images/object_icons_new/file.svg" class="img-fluid"
                    alt="">
                  <img *ngIf="value.type=='link'" src="assets/images/object_icons_new/link.svg" class="img-fluid"
                    alt="">
                  <img *ngIf="value.type=='exam'" src="assets/images/object_icons/quiz.svg" class="img-fluid" alt="">
                  <img *ngIf="value.type=='image'" src="assets/images/object_icons/image.svg" class="img-fluid" alt="">
                  <img *ngIf="value.type=='iframe'" src="assets/images/object_icons/iframe.svg" class="img-fluid"
                    alt="">
                </div>
                <div *ngIf="value.sub_tit" class="subs-txt">{{value.sub_tit}}</div>
                <div *ngIf="!value.sub_tit" class="subs-txt">Sub section {{j+1}}</div>
              </div>
              <div *ngIf="value.is_cp==1" class="me-1 me-lg-2"> <img src="assets/images/icons/tick_mark.svg"
                  class="img-fluid" alt="">
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>
</div>
<section class="content d-flex flex-column" [style.margin-left]="isSideMenuShow ? '400px':'27px'"
  [style.height]="smallDevcieBtn.isLandscape ? '100% !important':'calc(100vh - 82px)'">
  <div class="d-flex flex-column  flex-grow-1" *ngIf="!isSpinnerLoading"
    [ngClass]="{'box-item': coursePreviewType === 'desktop','theme-box': themeUrl !== ''}"
    [ngStyle]="{'background': themeUrl !== '' ? 'url(' +imageURL+ themeUrl + ')' : ''}">
    <div class="c-head d-flex align-items-center flex-wrap justify-content-between"
      [ngClass]="coursePreviewType=='mobile' ? 'ms-auto':''">
      <div *ngIf="coursePreviewType=='desktop'">
        <div class="heading-1"
          *ngIf="subSectionData.sub_t  && subSectionData.type!='audio' && (contentDetail.type!='exam' && contentDetail.type!='examList')">
          {{subSectionData.sub_t}}</div>
      </div>
      <div class="small-cont align-items-center justify-content-center">
        <div class="me-2 cir-icon" (click)="onBack()" *ngIf="(smallDevcieBtn.isBack)"><i
            class="material-icons">keyboard_arrow_left</i></div>
        <div class="me-2">{{subSectionData.sub_tit }}</div>
        <div class="cir-icon" (click)="onNext()"><i class="material-icons" *ngIf="(!isBtnDisabled&&isAllSettingsApplied)||
          ((progressValue == 100) && (smallDevcieBtn.isNext))||(subSectionData.is_cp)"> keyboard_arrow_right</i></div>
      </div>
      <div class="d-flex align-items-center ms-auto">
        <div (click)="onCopyText()" class="cursor-pointer" *ngIf="isCopyTextAllowed && subSectionData.type=='text'">
          <img class="me-3" src="assets/images/icons/copy_ic.svg" alt="">
        </div>
        <div (click)="onDownload()" class="cursor-pointer" *ngIf="isDownloadAllowed">
          <img src="assets/images/icons/download_ic .svg" alt="">
        </div>
        <div class="progress ms-4 ms-xl-4" *ngIf="coursePreviewType=='desktop'" [attr.data-value]="progressValue">
          <span class="progress-left">
            <span class="progress-bar border-primary"></span>
          </span>
          <span class="progress-right">
            <span class="progress-bar border-primary"></span>
          </span>
          <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
            <div class="text-black text-bold p-text">{{progressValue}}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-grow-1  d-flex flex-column" *ngIf="coursePreviewType=='desktop'">
      <div class="flex-grow-1 d-flex flex-column" *ngIf="contentDetail.type!='exam' && contentDetail.type!='examList'">

        <div class="mt-3 flex-grow-1" *ngIf="subSectionData.type=='text'" #scrollContainer (scroll)="onScroll()">
          <div class="ql-snow mt-3 flex-grow-1" *ngIf="subSectionData.type=='text'">
            <div class="ql-editor " [innerHtml]="subSectionData.data|safe:'html'"></div>
          </div>
        </div>
        <div class="c-content c-content-ht yt-ht" *ngIf="subSectionData.type=='youtube'">
          <iframe [src]="extractVideoId(subSectionData.data)" height="100%" width="100%" class="iframe-ytube"></iframe>
        </div>
        <div class="c-content flex-grow-1 d-flex" *ngIf="subSectionData.type=='video'">
          <video width="100%" height="100%" class="m-auto d-flex iframe-ytube" controls (pause)="pauseSound($event)"
            #video>
            <source [src]="getUrl(subSectionData.data)" type="video/mp4">
          </video>
        </div>
        <div class="c-iframe l-box" *ngIf="subSectionData.type=='link'">
          <iframe [src]="subSectionData.data | safe: 'resourceUrl'" class="iframe-ytube" height="100%" width="100%"
            id="iframe" style="background-color:#FFF"></iframe>
        </div>
        <div class="d-box flex-grow-1" *ngIf="subSectionData.type=='image'">
          <div>
            <img [src]="subSectionData.data" class="img-fluid">
          </div>
        </div>
        <div class=" flex-grow-1 d-box " *ngIf="subSectionData.type=='file'">
          <div>
            <img src="assets/images/object_icons/file_download.svg" class="img-fluid">
          </div>
          <button mat-raised-button class="mt-4 btn no-sh-btn  success-btn" type="button"
            (click)="onDownloadFile(subSectionData.data)">
            <img src="assets/images/icons/download.png" class="img-fluid me-2">Download</button>
        </div>
        <div class="c-content c-content-ht  l-box zoom-b c-pdf" *ngIf="subSectionData.type=='pdf'">
          <pdf-viewer [src]="subSectionData.data" [original-size]="false" [autoresize]="true" [zoom]="zoom"
            [zoom-scale]="'page-width'" (page-rendered)="pageRendered($event)"
            (after-load-complete)="afterLoadComplete($event)" style="width: 100%; height: 100%"></pdf-viewer>
        </div>
        <div class="c-iframe" *ngIf="subSectionData.type=='iframe'">
          <iframe  class="iframe-ytube" height="100%" width="100%" id="iframe" #miframe
            style="background-color:#FFF"></iframe>
        </div>
        <div class="c-content flex-grow-1 d-box" *ngIf="subSectionData.type=='audio'">
          <div class="audio-img">
            <img src="assets/images/object_icons/audio_xl.svg" class="img-fluid" alt="">
          </div>
          <div class="heading-1 mt-3 mt-xl-5">{{subSectionData.sub_t}}</div>
          <audio controls style="width:100%;max-width:700px" class="my-2" #audio (pause)="pauseSound($event)">
            <source [src]="subSectionData.data" type="audio/mpeg">
          </audio>
          <div class="play-btn d-box cursor-pointer" (click)="onPlayPauseAudio()">
            <i class="material-icons" *ngIf="isPlayButton">play_arrow</i>
            <i class="material-icons" *ngIf="!isPlayButton">pause</i>
          </div>
        </div>
        <div class="row d-flex justify-content-center  flex-wrap position-relative "
          *ngIf="subSectionData.type!='exam'">
          <div class="d-flex justify-content-center mb-3" *ngIf="subSectionData.type=='pdf'">
            <div class="d-flex zoom-buttons ">
              <div class="zoom-in pt-1" (click)="onZoomIn()">+</div>
              <div class="btn-b"></div>
              <div class="zoom-out" (click)="onZoomOut()">-</div>
            </div>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-center flex-wrap w-100 order-2 order-md-1 ">
            <button type="button" class="btn btn-outline-primary m-2 btn-margin new-bt" *ngIf="isBackAvailable"
              (click)="onBack()">{{"Back" |translate}}</button>
               
            <button mat-raised-button color="primary" class="m-2 primary-btn btn no-sh-btn btn-margin un-btn new-bt"
              type="submit" (click)="onSubmit()" [disabled]="isBtnDisabled||!isAllSettingsApplied"
              *ngIf="progressValue < 100 && !subSectionData.is_cp">{{isConfirmBtn ? 'I Understand & Continue'
              :'Next'}}</button>
            <button mat-raised-button color="primary" class="m-2 primary-btn btn no-sh-btn btn-margin" type="submit"
              (click)="onCompleted()" *ngIf="progressValue == 100 || subSectionData.is_cp">{{ progressValue==100 ?
              'Completed' :'Go to Next' }}</button>
          </div>


        </div>
      </div>

      <div class="c-content flex-grow-1" *ngIf="contentDetail.type=='exam' || contentDetail.type=='result'">
        <app-individual-exam [childData]="contentDetail"
          (childEvent)="examComponentEvent($event)"></app-individual-exam>
      </div>
      <div class="c-content flex-grow-1" *ngIf="contentDetail.type=='examList'">
        <app-exam-list [listData]="contentDetail.data" (childEvent)="examComponentEvent($event)"></app-exam-list>
      </div>
    </div>
  </div>
</section>